import React from "react";
import { Container, Image } from "react-bootstrap";
import DstButton from "../DstButton/DstButton";
import "./HeroSection.scss";

const HeroSection = () => {
  return (
    <div className="bg-navy py-5 overflow-hidden" id="hero-section">
      <Container className="text-center text-white mb-5">
        <div className="eyebrow text-orange">Test de positionnement</div>
        <h1 className="bg-navy">Évaluez vos connaissances</h1>
        <p>
          <span className="bg-navy">
            Vous souhaitez monter en compétences dans les métiers de la data et
            de l'IA ? <br />
            Mais vous ne pensez pas avoir le niveau technique requis…? <br />
            Répondez aux QCM pour découvrir votre niveau.
          </span>
        </p>
        <div className="position-relative">
          <div className="position-absolute custom-position z-0">
            <Image
              src="/assets/vector-line-orange.svg"
              alt=""
              aria-hidden="true"
              className="custom-line"
              fluid
            />
          </div>
          <DstButton
            value="Commencer"
            btnClass="px-3 py-2 position-relative z-1"
            clickFunction={() => {
              document.getElementById("quiz-container")?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            }}
          />
        </div>
      </Container>
    </div>
  );
};

export default HeroSection;
